// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"014df568","226":"bfb30b47","306":"3febbecd"}[chunkId] + ".chunk.js";
};